import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import titleIcon from '../../asset/img/myinfo_personal_title_icon.svg';

import Typography from '../../components/common/Typography';
import TextField from '../../components/common/TextField';
import CheckBox from '../../components/common/CheckBox';
import Button from '../../components/common/Button';
import { changeMyInfo, setReload } from './myInfoSlice';
import { formatPhoneNumber, getAlertMessageFunction } from '../../common/Util';
import Address from './address/index';

const PersonalInfo = ({ title }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('myInfo');
  const { myInfo, address } = useSelector(state => state.myInfo);
  const [addressOpen, setAddressOpen] = useState(false);
  const [form, setForm] = useState({
    htmInsaPerHTel: '',
    htmInsaPerEMail: '',
    htmInsaPerAddr: '',
  });

  useEffect(() => {
    if (myInfo) {
      setForm({
        htmInsaPerEMail: myInfo.htmInsaPerEMail || '',
        htmInsaPerHTel: myInfo.htmInsaPerHTel || '',
        htmInsaPerAddr: myInfo.htmInsaPerAddr || '',
      });
    }
  }, [myInfo]);

  useEffect(() => {
    if (address) {
      setForm({ ...form, htmInsaPerAddr: address });
    }
  }, [address]);

  const handleChange = e => {
    const { name, value } = e.target;
    if (name === 'htmInsaPerHTel') {
      if (value.replaceAll('-', '').length > 11) {
        return;
      }

      setForm({ ...form, [name]: value.replaceAll('-', '') });
    } else {
      setForm({ ...form, [name]: value });
    }
  };

  const handleSubmit = async () => {
    const alertMessage = getAlertMessageFunction();
    try {
      // 이메일 정규식 수정 - 더 유연한 도메인 지원
      let emailCheck =
        /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,}$/i;
      let phoneCheck = /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/;

      //올바른 이메일 형식인지 확인
      if (form.htmInsaPerEMail.length > 0 && !emailCheck.test(form.htmInsaPerEMail)) {
        alertMessage(t('alertMessage.emailCheckFail'));
        return;
      }

      if (form.htmInsaPerHTel.length > 0 && !phoneCheck.test(form.htmInsaPerHTel)) {
        alertMessage(t('alertMessage.phoneNumberCheckFail'));
        return;
      }

      const response = await dispatch(
        changeMyInfo({
          ...form,
          htm101: '1',
        }),
      ).unwrap();
      const { result } = response;
      if (result) {
        //개인정보 변경이 완료되었습니다.
        alertMessage(t('alertMessage.personalInfoChangeSuccess'));
        dispatch(setReload());
      } else {
        //개인정보 변경에 실패하였습니다.
        alertMessage(t('alertMessage.personalInfoChangeFail'));
      }
    } catch (error) {
      alertMessage(t('alertMessage.personalInfoChangeFail'));
    }
  };

  return (
    <div className="myInfoContentBox">
      {/* title */}
      <div className="displayFlex" style={{ gap: '10px' }}>
        <div className="myInfoTitleIcon">
          <img src={titleIcon} alt="personalInfoTitleIcon" />
        </div>
        <Typography>{title}</Typography>
      </div>

      {/* 비밀번호 input */}
      <div className="displayFlexColumn" style={{ gap: '10px' }}>
        {/* 휴대폰 */}
        <TextField
          placeholder={t('phoneNumberInputPlaceholder')}
          size="small"
          value={formatPhoneNumber(form.htmInsaPerHTel)}
          name="htmInsaPerHTel"
          onChange={handleChange}
        />
        {/* 이메일 */}
        <TextField
          placeholder={t('emailInputPlaceholder')}
          size="small"
          value={form.htmInsaPerEMail}
          name="htmInsaPerEMail"
          onChange={handleChange}
        />
        <div className="displayFlex" style={{ gap: '10px' }}>
          {/* 주소 */}
          <TextField
            placeholder={t('addressInputPlaceholder')}
            size="small"
            style={{ flex: '1' }}
            value={form.htmInsaPerAddr}
            readOnly
          />
          {/* 주소검색 */}
          <Button
            value={t('addressSearchButton')}
            variant="sub"
            size="small"
            onClick={() => setAddressOpen(true)}
          />
        </div>
      </div>

      <Button
        size="large"
        value={t('personalInfoButton')}
        color="secondary"
        onClick={handleSubmit}
      />

      {/* 주소검색 slide*/}
      <Address isOpen={addressOpen} onClose={() => setAddressOpen(false)} />
    </div>
  );
};

export default PersonalInfo;
